<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item
        v-if="origin == '0'"
        :to="{ path: '/dashboard/dealer/purchase_orders' }"
        >采购单列表</el-breadcrumb-item
      >
      <el-breadcrumb-item
        v-if="origin == '1' && purchaseOrder"
        :to="{
          path: '/dashboard/dealer/orders/' + purchaseOrder.customer_order_id,
        }"
        >{{ purchaseOrder.customer_order.number }}</el-breadcrumb-item
      >
      <el-breadcrumb-item>采购单详情</el-breadcrumb-item>
    </el-breadcrumb>
    <template v-if="purchaseOrder">
      <div class="panel mt-20">
        <div :class="{ 'flex-row-between': !isMobile() }">
          <div class="number-info">
            <p>
              <span class="sub">采购单号 #</span>
              <strong>
                {{ purchaseOrder.number }}
                <el-tag
                  size="small"
                  :type="PurchaseOrderStatusMap[purchaseOrder.status].type"
                >
                  {{ PurchaseOrderStatusMap[purchaseOrder.status].name }}
                </el-tag>
              </strong>
            </p>
            <p>
              <span class="text-info-12">
                {{ purchaseOrder.user.name }}
                {{ formatTime(purchaseOrder.created_at) }}
              </span>
            </p>
          </div>
          <div>
            <el-button
              slot="reference"
              size="mini"
              type="primary"
              plain
              v-if="hasOrderApplicationAuth"
              @click="handleApplication()"
              v-permission="Auth.purchaseOrderNew"
              >申请</el-button
            >
            <el-button
              size="mini"
              type="primary"
              plain
              @click="handleApprove()"
              v-if="purchaseOrder.status == 3"
              v-permission="Auth.purchaseOrderApprove"
              >审批</el-button
            >
            <template v-if="hasOrderEditAuth">
              <el-button
                size="mini"
                type="primary"
                plain
                @click="edit()"
                v-permission="Auth.purchaseOrderEdit"
                >编辑</el-button
              >
              <el-popconfirm
                class="ml-10"
                title="确认删除吗？"
                @confirm="confirmDelte()"
                v-permission="Auth.purchaseOrderDelete"
              >
                <el-button slot="reference" type="danger" plain size="mini"
                  >删除</el-button
                >
              </el-popconfirm>
            </template>
          </div>
        </div>
      </div>
      <el-row :gutter="14">
        <el-col :span="18">
          <div class="panel mt-20">
            <div class="header">
              <h2>产品明细</h2>
            </div>
            <el-table :data="purchaseOrder.items" v-if="purchaseOrder">
              <el-table-column label="对象" width="60px">
                <template slot-scope="scope">
                  {{ scope.row.item.category == 1 ? '零件' : '设备' }}
                </template>
              </el-table-column>
              <el-table-column
                prop="item.name"
                label="名称"
                min-width="250px"
              ></el-table-column>
              <el-table-column
                prop="item.part_number"
                label="件号"
                min-width="120px"
              ></el-table-column>
              <el-table-column
                prop="item.machine_type"
                label="机型"
                min-width="120px"
              ></el-table-column>
              <el-table-column label="单价" width="80">
                <template slot-scope="scope">
                  {{ scope.row.price.toFixed(2) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="count"
                label="数量"
                width="80"
              ></el-table-column>
            </el-table>
          </div>

          <div class="panel mt-20">
            <div class="header">
              <h2>操作记录</h2>
            </div>
            <ul class="logs">
              <li v-for="log in purchaseOrder.logs">
                <p class="flex-row-between">
                  <span class="text-dark">
                    {{ PurchaseOrderLogMap[log.type] }}
                  </span>
                  <span class="text-primary">{{ log.user.name }}</span>
                </p>
                <p>
                  {{ log.content }}
                  <order-link
                    v-if="log.type == 1 && log.params && log.params.id"
                    :order="log.params"
                  ></order-link>
                </p>
                <p class="text-info-12">
                  {{ formatTime(log.created_at, 'YYYY-M-D HH:mm') }}
                </p>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="panel mt-20">
            <div class="header">
              <h2>备注</h2>
            </div>
            <div v-if="purchaseOrder.remark.length > 0">
              {{ purchaseOrder.remark }}
            </div>
            <div class="text-info-12" v-else>无</div>
          </div>
        </el-col>
      </el-row>
    </template>
    <purchase-order-former
      :model="purchaseOrderForm"
      :fixedOrder="true"
      :show.sync="purchaseOrderVisible"
      @updated="updatedPurchaseOrder"
    ></purchase-order-former>
    <purchase-order-application
      :model="application"
      :show.sync="applicationDialogVisible"
      @updated="confirmApprove"
    ></purchase-order-application>
  </div>
</template>

<script>
import auth from '@/util/auth'
import store from '@/store/store'
import { formatTime } from '@/util/index'
import PurchaseOrderFormer from '@/components/purchase_order'
import purchaseOrderApplication from '@/components/purchase_order_application'
import {
  deletePurchaseOrder,
  purchaseOrderStatusChange,
  purchaseOrderDetail,
} from '../../service/getData'

import { PurchaseOrderStatusMap, PurchaseOrderLogMap } from '@/config/global'
import { clone } from '@/util'
import { isMobile } from '../../util'

export default {
  components: { PurchaseOrderFormer, purchaseOrderApplication },
  data() {
    return {
      auth,
      isMobile,
      userInfo: store.state.userInfo,
      purchaseOrder: null,
      purchaseOrderForm: {},
      formatTime,
      origin: this.$route.query.origin,
      id: parseInt(this.$route.params.id),
      purchaseOrderVisible: false,
      PurchaseOrderStatusMap,
      PurchaseOrderLogMap,
      applicationDialogVisible: false,
      application: {},
    }
  },
  created() {
    this.requestPurchaseOrderDetail()
  },
  computed: {
    hasOrderApplicationAuth() {
      return (
        this.userInfo.id == this.purchaseOrder.creator_id &&
        (this.purchaseOrder.status == 1 || this.purchaseOrder.status == 5)
      )
    },
    hasOrderEditAuth() {
      return (
        this.userInfo.id == this.purchaseOrder.creator_id &&
        this.purchaseOrder.status != 9
      )
    },
  },
  methods: {
    async requestPurchaseOrderDetail() {
      let res = await purchaseOrderDetail(this.id)
      if (res.code == 0) {
        this.purchaseOrder = res.data
      }
    },
    edit() {
      this.purchaseOrderForm = clone(this.purchaseOrder)
      if (this.purchaseOrderForm.customer_order_id == 0) {
        this.purchaseOrderForm.customer_order_id = ''
      }
      this.purchaseOrderVisible = true
    },
    updatedPurchaseOrder(po) {
      this.requestPurchaseOrderDetail()
      // this.purchaseOrder = po
    },
    handleApprove(item, index) {
      let that = this
      this.$confirm('请选择审核结果', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '通过',
        cancelButtonText: '不通过',
        center: true,
      })
        .then(() => {
          purchaseOrderStatusChange({
            id: that.id,
            status: 7,
          }).then((res) => {
            that.requestPurchaseOrderDetail()
          })
        })
        .catch((action) => {
          if (action === 'cancel') {
            purchaseOrderStatusChange({
              id: that.id,
              status: 5,
            }).then((res) => {
              that.requestPurchaseOrderDetail()
            })
          }
        })
    },
    handleApplication() {
      this.application = {
        id: this.purchaseOrder.id,
        number: this.purchaseOrder.number,
        approver_id: '',
      }
      this.applicationDialogVisible = true
    },
    confirmApprove(data) {
      this.requestPurchaseOrderDetail()
      // this.purchaseOrder.status = data.status
    },
    async confirmDelte() {
      let res = await deletePurchaseOrder(this.id)
      if (res.code == 0) {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style scoped>
.number {
  font-size: 16px;
}
.details li {
  padding: 8px 0;
  display: flex;
}

.details li .title {
  width: 80px;
}

.title {
  color: #888;
}

.logs li {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 8px 0;
}
.logs li:last-child {
  border-bottom: 0 none;
}
.logs p {
  margin: 0 0 5px 0;
}
.logs p:nth-child(2) {
  font-size: 12px;
}
.logs p:last-child {
  margin: 0;
}
</style>